import { useState } from 'react';
import { Check } from '@mui/icons-material';
import { Chip, Stack, Typography } from '@mui/material';
import { availability } from './availability';
import { ConfirmDialog } from '@/components/shared/confirm-dialog';

interface WeeklyAvailabilityEditDialogProps {
  currentValue: number | null;
  hasValue: boolean;
  onClose: () => void;
  onSave: (value: number | null) => void;
}

export const WeeklyAvailabilityEditDialog = ({
  currentValue,
  hasValue,
  onClose,
  onSave,
}: WeeklyAvailabilityEditDialogProps) => {
  const [value, setValue] = useState(currentValue);
  const [isDirty, setIsDirty] = useState(hasValue);

  const handleSave = () => {
    onSave(value);
    onClose();
  };

  const handleChange = (value: number) => {
    setIsDirty(true);
    setValue(value);
  };

  return (
    <ConfirmDialog
      actionLabels={{
        cancel: 'Cancelar',
        confirm: 'Salvar',
      }}
      onClose={onClose}
      open
      onConfirm={handleSave}
      title="Disponibilidade semanal"
    >
      <Stack gap={1} alignItems="flex-start">
        <Typography>Selecione a disponibilidade semanal</Typography>
        {availability.map(({ label, value: optionValue }) => {
          const isChecked = isDirty ? value === optionValue : false;
          return (
            <Chip
              key={optionValue}
              label={label}
              variant={isChecked ? 'filled' : 'outlined'}
              icon={isChecked ? <Check /> : undefined}
              onClick={() => {
                handleChange(optionValue);
              }}
            />
          );
        })}
      </Stack>
    </ConfirmDialog>
  );
};
